/**
 * Action types for ap dashboard graph functionality.
 * These constants are typically used in Redux action creators and reducers to handle connected clients graph.
*/

// channel info for 5GHz
export const AP_CHANNEL_INFO_5GH_API_REQUEST = 'AP_CHANNEL_INFO_5GH_API_REQUEST';
export const AP_CHANNEL_INFO_5GH_API_SUCCESS = 'AP_CHANNEL_INFO_5GH_API_SUCCESS';
export const AP_CHANNEL_INFO_5GH_API_FAIL = 'AP_CHANNEL_INFO_5GH_API_FAIL';

// channel info for 2.4GHz
export const AP_CHANNEL_INFO_2GH_API_REQUEST = 'AP_CHANNEL_INFO_2GH_API_REQUEST';
export const AP_CHANNEL_INFO_2GH_API_SUCCESS = 'AP_CHANNEL_INFO_2GH_API_SUCCESS';
export const AP_CHANNEL_INFO_2GH_API_FAIL = 'AP_CHANNEL_INFO_2GH_API_FAIL';

// channel utilization for 2.4GHz
export const AP_CHANNEL_UTILIZATION_2GH_API_REQUEST = 'AP_CHANNEL_UTILIZATION_2GH_API_REQUEST';
export const AP_CHANNEL_UTILIZATION_2GH_API_SUCCESS = 'AP_CHANNEL_UTILIZATION_2GH_API_SUCCESS';
export const AP_CHANNEL_UTILIZATION_2GH_API_FAIL = 'AP_CHANNEL_UTILIZATION_2GH_API_FAIL';

// channel utilization for 5GHz
export const AP_CHANNEL_UTILIZATION_5GH_API_REQUEST = 'AP_CHANNEL_UTILIZATION_5GH_API_REQUEST';
export const AP_CHANNEL_UTILIZATION_5GH_API_SUCCESS = 'AP_CHANNEL_UTILIZATION_5GH_API_SUCCESS';
export const AP_CHANNEL_UTILIZATION_5GH_API_FAIL = 'AP_CHANNEL_UTILIZATION_5GH_API_FAIL';

// extension channel  for 2.4GHz
export const AP_CHANNEL_EXTENSION_24GH_API_REQUEST = 'AP_CHANNEL_EXTENSION_24GH_API_REQUEST';
export const AP_CHANNEL_EXTENSION_24GH_API_SUCCESS = 'AP_CHANNEL_EXTENSION_24GH_API_SUCCESS';
export const AP_CHANNEL_EXTENSION_24GH_API_FAIL = 'AP_CHANNEL_EXTENSION_24GH_API_FAIL';

// extension channel  for 5GHz
export const AP_CHANNEL_EXTENSION_5GH_API_REQUEST = 'AP_CHANNEL_EXTENSION_5GH_API_REQUEST';
export const AP_CHANNEL_EXTENSION_5GH_API_SUCCESS = 'AP_CHANNEL_EXTENSION_5GH_API_SUCCESS';
export const AP_CHANNEL_EXTENSION_5GH_API_FAIL = 'AP_CHANNEL_EXTENSION_5GH_API_FAIL';

//  rogue value for 2.4GHz
export const AP_ROGUE_24GH_API_REQUEST = 'AP_ROGUE_24GH_API_REQUEST';
export const AP_ROGUE_24GH_API_SUCCESS = 'AP_ROGUE_24GH_API_SUCCESS';
export const AP_ROGUE_24GH_API_FAIL = 'AP_ROGUE_24GH_API_FAIL';

//  rogue value for 2.4GHz
export const AP_ROGUE_5GH_API_REQUEST = 'AP_ROGUE_5GH_API_REQUEST';
export const AP_ROGUE_5GH_API_SUCCESS = 'AP_ROGUE_5GH_API_SUCCESS';
export const AP_ROGUE_5GH_API_FAIL = 'AP_ROGUE_5GH_API_FAIL';